import * as Yup from "yup";
import { TASK_STATUS } from "../../constants/tasks";

export const taskSchema = Yup.object().shape({
    title: Yup.string().required("O título é obrigatório"),
    description: Yup.string(),
    scheduledDate: Yup.string().required("A data é obrigatória"),
    scheduledTime: Yup.string(),
    type: Yup.string().required("Selecione o tipo de tarefa"),
    priority: Yup.string().required("A prioridade é obrigatória"),
    status: Yup.string()
        .required("O status é obrigatório")
        .oneOf(Object.values(TASK_STATUS), "Status inválido"),
});
